import { render, staticRenderFns } from "./testGreen.vue?vue&type=template&id=252c40ba&scoped=true&"
import script from "./testGreen.vue?vue&type=script&lang=js&"
export * from "./testGreen.vue?vue&type=script&lang=js&"
import style0 from "./testGreen.vue?vue&type=style&index=0&id=252c40ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252c40ba",
  null
  
)

export default component.exports